import { BoxProps } from '../../../../../libs/ui-new/src'
import { isMobileWidth, isTabletWidth } from '../../util/util'

const styles = (breakpoint: number, responsivePadding: number) => {
  const isMobile = isMobileWidth(breakpoint)
  const isTab = isTabletWidth(breakpoint)
  console.log(isMobile)
  return {
    outerontainer: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'scroll',
      margin: 0,
      padding: 0,
      bg: 'WHITE',
      maxHeight: 'calc(100vh - 72px)',
    } as BoxProps,
    container: {
      display: 'flex',
      bg: 'WHITE',
      position: 'relative',
      flexWrap: 'wrap-reverse',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: responsivePadding,
      paddingVertical: !isMobile ? 80 : 20,
      minHeight: isMobile || isTab ? '80vh' : undefined,
    } as BoxProps,
    imageContainer: {
      display: 'flex',
      width: '50%',
      minWidth: isMobile ? '100%' : 300,
      minHeight: isMobile ? 300 : 400,
      marginRight: isMobile ? -30 : isTab ? -8 : -32,
      justifyContent: isMobile ? 'center' : 'flex-start',
      alignItems: isMobile ? 'center' : 'flex-end',
    } as BoxProps,
    leftBox: {
      display: 'flex',
      width: isMobile ? '100%' : '45%',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    } as BoxProps,
  }
}

export { styles }
